import React from "react";
import { Box, Typography, Badge } from "@mui/material";
import { Dashboard, School, People, CalendarMonth, SwapHoriz, Tune } from "@mui/icons-material";

// PC 전용 좌측 내비게이션 레일. section 상태를 controlled 방식으로 관리한다.
const ITEMS = [
  { key: "dashboard", label: "대시보드", icon: <Dashboard /> },
  { key: "teachers", label: "선생님", icon: <School /> },
  { key: "members", label: "회원", icon: <People /> },
  { key: "schedule", label: "스케줄", icon: <CalendarMonth /> },
  { key: "planner", label: "플래너", icon: <SwapHoriz /> },
  { key: "operations", label: "운영 설정", icon: <Tune /> },
];

export default function AdminSidebar({ section, onChange, darkMode, pendingCount = 0 }) {
  return (
    <Box
      sx={{
        width: 78,
        flexShrink: 0,
        borderRight: 1,
        borderColor: "divider",
        py: 1,
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        bgcolor: darkMode ? "grey.900" : "grey.50",
      }}
    >
      {ITEMS.map((item) => {
        const active = section === item.key;
        return (
          <Box
            key={item.key}
            role="button"
            aria-label={item.label}
            aria-current={active ? "page" : undefined}
            onClick={() => onChange(item.key)}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.5,
              py: 1.25,
              mx: 0.75,
              borderRadius: 2,
              cursor: "pointer",
              userSelect: "none",
              color: active ? "primary.main" : "text.secondary",
              bgcolor: active ? "action.selected" : "transparent",
              transition: "background-color .15s",
              "&:hover": { bgcolor: active ? "action.selected" : "action.hover" },
              "& svg": { fontSize: 24 },
            }}
          >
            {item.key === "dashboard" && pendingCount > 0 ? (
              <Badge color="error" badgeContent={pendingCount} max={99}>
                {item.icon}
              </Badge>
            ) : (
              item.icon
            )}
            <Typography sx={{ fontSize: 11, fontWeight: active ? 700 : 500, lineHeight: 1 }}>
              {item.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
